<template>
  <div class="d-flex justify-content-center mb-4">
    <section class="news-section" style="padding: 0; max-width: 1200px !important">
      <div class="container" style="max-width: 600px !important">
        <div class="section-title mb-2">
          <h2
            style="font-size: 1.5rem; font-weight: 500; color: #2c3e50;"
          >
            {{ comp.task }}
          </h2>
          <!-- <p style="color: #6c757d; font-size: 1.1rem;">{{ comp.f1 }}</p> -->
        </div>
      </div>
      <div class="container">
        <div class="row g-4">
          <div
            class="col-12 col-sm-6 col-md-6 col-lg-3"
            v-for="(t, i) in tasks"
            :key="i"
          >
            <div class="news-card">
              <a
                v-if="
                  $store.state.app.activeGroup.publicPage.readUrl !== undefined &&
                    $store.state.app.activeGroup.publicPage.readUrl !== ''
                "
                target="_blank"
                :href="
                  `${$store.state.app.activeGroup.publicPage.readUrl}/c/${$store.state.app.contentPageId}?cid=${t.id}`
                "
                class="news-link"
              >
                <div class="news-image-container">
                  <img
                    :src="`${t.defaultAttachmentUrl}?w=400&h=250&mode=crop`"
                    class="news-image"
                    :alt="t.task"
                  />
                </div>
                <div class="news-content">
                  <h3 class="news-title3">{{ t.task }}</h3>
                  <div class="news-meta">
                    <span class="news-category">ЗААВАР ҮЗЭХ</span>
                  </div>
                </div>
              </a>
              <router-link
                v-else
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: {
                    id: $store.state.app.contentPageId,
                    cid: t.id
                  }
                }"
                class="news-link"
              >
                <div class="news-image-container">
                  <img
                    :src="`${t.defaultAttachmentUrl}?w=400&h=250&mode=crop`"
                    class="news-image"
                    :alt="t.task"
                  />
                </div>
                <div class="news-content">
                  <h3 class="news-title3">{{ t.task }}</h3>
                  <div class="news-meta">
                    <span></span>
                    <span class="news-category">ЗААВАР ҮЗЭХ</span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      //console.log('=>', this.comp);
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 8,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style scoped>
.news-section {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.news-card {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  position: relative;
}

.news-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.news-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}

.news-link:hover {
  text-decoration: none;
  color: inherit;
}

.news-image-container {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.news-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-card:hover .news-image {
  transform: scale(1.05);
}

.news-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 180px);
  min-height: 120px;
}

.news-title3 {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #2c3e50;
  margin: 0 0 15px 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  flex-grow: 1;
}

.news-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 10px;
}

.news-date {
  font-size: 13px;
  color: #6c757d;
  font-weight: 400;
}

.news-category {
  background: #007bff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsive adjustments */
@media (max-width: 1199.98px) {
  .news-card {
    margin-bottom: 20px;
  }
}

@media (max-width: 767.98px) {
  .news-image-container {
    height: 180px;
  }

  .news-content {
    padding: 16px;
    min-height: 120px;
  }

  .news-title3 {
    font-size: 15px;
  }
}

@media (max-width: 575.98px) {
  .news-image-container {
    height: 200px;
  }

  .news-content {
    padding: 18px;
  }

  .news-title3 {
    font-size: 16px;
  }
}

/* Grid spacing */
.row.g-4 {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 1.5rem;
}

.row.g-4 > * {
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}
</style>
